import {SearchModelBase} from './SearchModelBase';
import * as XCol from '../../framework.core/XExportColumn';
import _ from 'lodash';

export enum OihListType {
    Normal,
    NormalCan,
    UseLot,
    HblInfo
}

export class OiHblListItem extends SearchModelBase {
    closed: string = '';
    isClosed: boolean|null = null;
    invStat: string = '';
    billStat: string = '';
    crDbStat: string = '';
    postDate: string | null = null;
    hblNo: string = '';
    branch: string = '';
    custFName: string = '';
    custSName: string = '';
    hasCLimit: string = '';
    refNo: string = '';
    mblNo: string = '';
    soNo: string = '';
    projectNo: string = '';
    shipmentId: string = '';
    cargoNo: string = '';
    itNo: string = '';
    itPlace: string = '';
    oblStat: string = '';
    
    oblDate: string | null = null;
    fromOblDate: string | null = null;
    toOblDate: string | null = null;
    rlsStat: string = '';

    rlsDate: string | null = null;
    fromRlsDate: string | null = null;
    toRlsDate: string | null = null;
    rlsBy: string = '';
    payStat: string = '';
    payDate: string | null = null;
    fromPayDate: string | null = null;
    toPayDate: string | null = null;
    moveType: string = '';
    anFax: string | null = null;
    fromAnFax: string | null = null;
    toAnFax: string | null = null;
    anEmail: string | null = null;
    fromAnEmail: string | null = null;
    toAnEmail: string | null = null;
    doorMove: boolean|null = null;
    cClear: boolean|null = null;
    cHold: boolean|null = null;
    pkgs: number|null = null;
    fromPkgs: number|null = null;
    toPkgs: number|null = null;
    lbs: number|null = null;
    fromLbs: number|null = null;
    toLbs: number|null = null;
    kgs: number|null = null;
    fromKgs: number|null = null;
    toKgs: number|null = null;
    cbm: number|null = null;
    fromCbm: number|null = null;
    toCbm: number|null = null;
    lPort: string = '';
    fDest: string = '';
    commodity: string = '';
    operator: string = '';
    csr: string = '';
    createdAt: string | null = null;
    fromCreatedAt: string | null = null;
    toCreatedAt: string | null = null;
    custRefNo: string = '';
    eta: string | null = null;
    fromEta: string | null = null;
    toEta: string | null = null;
    fEta: string | null = null;
    fromFEta: string | null = null;
    toFEta: string | null = null;
    lastFreeDay: string | null = null;
    fromLastFreeDay: string | null = null;
    toLastFreeDay: string | null = null;
    cntrNo: string = '';
    fullCntrNo: string = '';
    cntrType: string = '';
    sManID: string = '';
    aName: string = '';
    sName: string = '';
    shipperName: string | null = null;
    cName: string = '';
    consigneeName: string | null = null;
    nName: string = '';
    notifyName: string | null = null;
    bName: string = '';
    brokerName: string | null = null;
    subMBl: string = '';
    subBl: string = '';
    poNo: string = '';
    amsBlNo: string = '';
    fWhse: string = '';
    dvnEdi: string | null = null;
    fromDvnEdi: string | null = null;
    toDvnEdi: string | null = null;
    rlsEdi: string | null = null;
    fromRlsEdi: string | null = null;
    toRlsEdi: string | null = null;
    doorDlvLoc: string = '';
    vessel: string = '';
    voyage: string = '';
    dPort: string = '';
    isfNo: string = '';
    canShareFile: boolean = false;
    pimsLinkId: number = 0;
    amsLinkId: number = 0;
    id: number = 0;
    deliverToName: string = '';
    shipmentType: string = '';
    doorDlvETA: string | null = null;
    fromDoorDlvETA: string | null = null;
    toDoorDlvETA: string | null = null;
    anPrint: string | null = null;
    fromAnPrint: string | null = null;
    toAnPrint: string | null = null;
    lotNo: string = '';

    trackerDate: string | null = null;
    fromTrackerDate: string | null = null;
    toTrackerDate: string | null = null;
    trackerUser: string = '';
    
    lastTrackedDate: string | null = null;
    fromLastTrackedDate: string | null = null;
    toLastTrackedDate: string | null = null;
    lastTrackedUser: string = '';
    
    anPrintedDate: string | null = null;        // ** 이름은 PrtChk으로 되어있지만 실제 Email or Fax를 전송했을 때 설정된다.
    fromANPrintedDate: string | null = null;
    toANPrintedDate: string | null = null;
    anPrintedUser: string = '';
    
    cDocRcvdDate: string | null = null;
    fromCDocRcvdDate: string | null = null;
    toCDocRcvdDate: string | null = null;
    cDocRcvdUser: string = '';
    
    eDocSentDate: string | null = null;
    fromEDocSentDate: string | null = null;
    toEDocSentDate: string | null = null;
    eDocSentUser: string = '';
    
    f7501RcvdDate: string | null = null;
    from7501RcvdDate: string | null = null;
    to7501RcvdDate: string | null = null;
    f7501RcvdUser: string = '';
    
    f3461RcvdDate: string | null = null;
    from3461RcvdDate: string | null = null;
    to3461RcvdDate: string | null = null;
    f3461RcvdUser: string = '';
    
    inlandNoticeSentDate: string | null = null;
    fromInlandNoticeSentDate: string | null = null;
    toInlandNoticeSentDate: string | null = null;
    inlandNoticeSentUser: string = '';
    
    puInfoSentDate: string | null = null;
    fromPUInfoSentDate: string | null = null;
    toPUInfoSentDate: string | null = null;
    puInfoSentUser: string = '';
    
    doReceiptCfrmdDate: string | null = null;
    fromDoReceiptCfrmdDate: string | null = null;
    toDoReceiptCfrmdDate: string | null = null;
    doReceiptCfrmdUser: string = '';
    
    doSentDate: string | null = null;
    fromDOSentDate: string | null = null;
    toDOSentDate: string | null = null;
    doSentUser: string = '';
    
    dlvAddrCfrmdDate: string | null = null;
    fromDlvAddrCfrmdDate: string | null = null;
    toDlvAddrCfrmdDate: string | null = null;
    dlvAddrCfrmdUser: string = '';
    
    dlvSchdDate: string | null = null;
    fromDlvSchdDate: string | null = null;
    toDlvSchdDate: string | null = null;
    dlvSchdUser: string = '';
    
    actDlvDate: string | null = null;
    fromActDlvDate: string | null = null;
    toActDlvDate: string | null = null;
    actDlvUser: string = '';
    
    emptyRtnDate: string | null = null;
    fromEmptyRtnDate: string | null = null;
    toEmptyRtnDate: string | null = null;
    emptyRtnUser: string = '';
    
    podRcvdDate: string | null = null;
    fromPODRcvdDate: string | null = null;
    toPODRcvdDate: string | null = null;
    podRcvdUser: string = '';
    
    billingCpldDate: string | null = null;
    fromBillingCpldDate: string | null = null;
    toBillingCpldDate: string | null = null;
    billingCpldUser: string = '';

    mailDate: string | null = null;
    fromMailDate: string | null = null;
    toMailDate: string | null = null;
    mailUser: string = '';
    oiMblId: number = 0;
    confirmDate: string | null = null;
    fromConfirmDate: string | null = null;
    toConfirmDate: string | null = null;
    etd: string | null = null;
    expRls: boolean = false;
    oblCol: string = '';
    recognized: string = '';
    status: string = '';

    // cloud
    bizMode: string = '';
    u2Date: string | null = null;
    fromU2Date: string | null = null;
    toU2Date: string | null = null;
    u2ID: string = '';
    u1ID: string = '';
    canBeDeleted: boolean = false;
    //anPrtChk: boolean = false;      // ** 이름은 PrtChk으로 되어있지만 실제 Email or Fax를 전송했을 때 설정된다.
    lclFcl: string | null = null;

    //A/N Last Log Date
    anLastLogDate: string | null = null;
    fromAnLastLogDate: string | null = null;
    toAnLastLogDate: string | null = null;

    //PGA Hold
    fdaHoldDate: string | null = null;
    fromFdaHoldDate: string | null = null;
    toFdaHoldDate: string | null = null;

    //PGA Rls
    fdaRlsDate: string | null = null;
    fromFdaRlsDate: string | null = null;
    toFdaRlsDate: string | null = null;

    //Customs Rls
    clearDate: string | null = null;
    fromClearDate: string | null = null;
    toClearDate: string | null = null;

    //Customs Hold
    cHoldDate: string | null = null;
    fromCHoldDate: string | null = null;
    toCHoldDate: string | null = null;

    //Exam On
    examOnDate: string | null = null;
    fromExamOnDate: string | null = null;
    toExamOnDate: string | null = null;

    //Exam Off
    examOffDate: string | null = null;
    fromExamOffDate: string | null = null;
    toExamOffDate: string | null = null;

    //DDP
    ddpDate: string | null = null;      
    fromDdpDate: string | null = null;
    toDdpDate: string | null = null;

    // Need to check if it's returned from server. currently service is down.
    // It is added to avoid compile error
    customer: number = 0

    trType: string = ''
    trStatus:string=''
    trStatusDesc:string=''
    trDate: string | null = null;
    fromTrDate: string | null = null;
    toTrDate: string | null = null;

    //Track Event
    lastEvent: string = '';
    lastEventDate: string | null = null;

    //useChb: boolean = false;
    //useIsf: boolean = false;
    //useAms: boolean = false;
    useAmsBlNo: boolean = false;
    useIsfNo: boolean = false;
    useAms: boolean = false;
    useIsf: boolean = false;
    chbRspCode: string = '';
    chbRspMsg: string = '';
    amsHouseId: number = 0; 

    remark: string = '';

    //memo
    memoCnt: string = ''; // total memo count
    taskPendingCnt: number = 0; // 로그인했을때 해당 유저로 Assign 된 Pending Task 개수
    directBl: boolean = false;
    sbl: boolean = false;
    agentCnt: number = 0;  // total agent count

    //outDate
    outDate: string | null = null;      
    fromOutDate: string | null = null;
    toOutDate: string | null = null;

        //emptyReturn
    emptyReturn: string | null = null;      
    fromEmptyReturn: string | null = null;
    toEmptyReturn: string | null = null;

    private static ExportCollection: XCol.XExportColumn[] = [
        XCol.Create({ col: 0, text: 'S', width: 30, dataIndex: 'status', canBeHidden: false, resizable: false, sortable: true, hiddenInColumnSetup: true }),
        XCol.Create({ col: 1, text: 'R.Date', width: 80, dataIndex: 'confirmDate', hiddenInColumnSetup: true, type: XCol.XCellType.Date, align: XCol.XAlignType.Center, visible: true }),
        XCol.Create({ col: 2, text: 'D/ID', width: 35, dataIndex: 'shipmentType', resizable: false, sortable: true, noNullOrEmptySearch: true }),
        XCol.Create({ col: 3, text: 'INV', width: 35, dataIndex: 'invStat', align: XCol.XAlignType.Center, resizable: false, sortable: true, noNullOrEmptySearch: true}),
        XCol.Create({ col: 4, text: 'BIL', width: 35, dataIndex: 'billStat', align: XCol.XAlignType.Center, resizable: false, sortable: true, noNullOrEmptySearch: true}),
        XCol.Create({ col: 5, text: 'CrDb', width: 35, dataIndex: 'crDbStat', align: XCol.XAlignType.Center, resizable: false, sortable: true, noNullOrEmptySearch: true}),
        
        XCol.Create({ col: 6, text: 'HBL', width: 130, dataIndex: 'hblNo' }),

        XCol.Create({ col: 7, text: 'AMS', width: 50, dataIndex: 'useAmsBlNo', type: XCol.XCellType.Bool, align: XCol.XAlignType.Center, noNullOrEmptySearch: true, visible: false }),
        XCol.Create({ col: 8, text: 'ISF', width: 50, dataIndex: 'useIsfNo', type: XCol.XCellType.Bool, align: XCol.XAlignType.Center, noNullOrEmptySearch: true, visible: false }),
        XCol.Create({ col: 9, text: 'CBP', width: 40, dataIndex: 'chbRspCode', align: XCol.XAlignType.Center, noNullOrEmptySearch: true, visible: false }),

        XCol.Create({ col: 10, text: 'BR', width: 40, dataIndex: 'branch', align: XCol.XAlignType.Center }),
        XCol.Create({ col: 11, text: 'Customer', width: 120, dataIndex: 'custSName' }),
        XCol.Create({ col: 12, text: 'Credit', width: 60, dataIndex: 'hasCLimit', type: XCol.XCellType.Bool, align: XCol.XAlignType.Center, noNullOrEmptySearch: true }),

        XCol.Create({ col: 13, text: 'Cargo', width: 80, dataIndex: 'lclFcl', visible: true, noNullOrEmptySearch: true}),
        XCol.Create({ col: 14, text: 'Ref. #', width: 100, dataIndex: 'refNo', defaultColumnFocus: true }),
        XCol.Create({ col: 15, text: 'SBL', width: 50, dataIndex: 'sbl', type: XCol.XCellType.Bool, align: XCol.XAlignType.Center, noNullOrEmptySearch: true }),
        XCol.Create({ col: 16, text: 'Task/Memo', width: 80, dataIndex: 'memoCnt', align: XCol.XAlignType.Center }),
        XCol.Create({ col: 17, text: 'RQ Date', width: 100, dataIndex: 'trDate', type: XCol.XCellType.DateTime, align: XCol.XAlignType.Center }),
        XCol.Create({ col: 18, text: 'Container Tracking', width: 210, dataIndex: 'trStatus' }),
        
        // XCol.Create({ col: 10, text: 'Last Event', width: 85, dataIndex: 'lastEvent', noNullOrEmptySearch: true }),

        XCol.Create({ col: 19, text: 'MBL', width: 100, dataIndex: 'mblNo' }),
        XCol.Create({ col: 20, text: 'S/O', width: 80, dataIndex: 'soNo' }),
        XCol.Create({ col: 21, text: 'AMS #', width: 110, dataIndex: 'amsBlNo' }),
        XCol.Create({ col: 22, text: 'ISF #', width: 110, dataIndex: 'isfNo' }),

        XCol.Create({ col: 23, text: 'Project ID', width: 80, dataIndex: 'projectNo' }),
        XCol.Create({ col: 24, text: 'In-bond', width: 80, dataIndex: 'itNo' }),
        XCol.Create({ col: 25, text: 'O B/L', width: 50, dataIndex: 'oblStat', align: XCol.XAlignType.Center, noNullOrEmptySearch: true }),
        XCol.Create({ col: 26, text: 'O B/L RCVD', width: 75, dataIndex: 'oblDate', type: XCol.XCellType.Date, align: XCol.XAlignType.Center }),
        XCol.Create({ col: 27, text: 'RLSD', width: 50, dataIndex: 'rlsStat' }),
        XCol.Create({ col: 28, text: 'Cargo RLSD', width: 75, dataIndex: 'rlsDate', type: XCol.XCellType.Date, align: XCol.XAlignType.Center }),
        XCol.Create({ col: 29, text: 'P', width: 40, dataIndex: 'payStat', align: XCol.XAlignType.Center }),
        XCol.Create({ col: 30, text: 'Paid', width: 75, dataIndex: 'payDate', type: XCol.XCellType.Date, align: XCol.XAlignType.Center }),
        XCol.Create({ col: 31, text: 'Move Type', width: 80, dataIndex: 'moveType', align: XCol.XAlignType.Center, noNullOrEmptySearch: true }),
        XCol.Create({ col: 32, text: 'A/N', width: 120, dataIndex: 'anLastLogDate', type: XCol.XCellType.DateTime, align: XCol.XAlignType.Center }),
        XCol.Create({ col: 33, text: 'DR', width: 50, dataIndex: 'doorMove', type: XCol.XCellType.Bool, align: XCol.XAlignType.Center, noNullOrEmptySearch: true }),
        XCol.Create({ col: 34, text: 'CC', width: 50, dataIndex: 'cClear', type: XCol.XCellType.Bool, align: XCol.XAlignType.Center, noNullOrEmptySearch: true }),
        XCol.Create({ col: 35, text: 'CH', width: 50, dataIndex: 'cHold', type: XCol.XCellType.Bool, align: XCol.XAlignType.Center, noNullOrEmptySearch: true }),
        XCol.Create({ col: 36, text: 'PKG(s)', width: 60, dataIndex: 'pkgs', type: XCol.XCellType.Double, align: XCol.XAlignType.Right, formatString: '#,##0', noNullOrEmptySearch: true }),
        XCol.Create({ col: 37, text: 'LBS', width: 60, dataIndex: 'lbs', type: XCol.XCellType.Double, align: XCol.XAlignType.Right, formatString: '#,##0.00', noNullOrEmptySearch: true }),
        XCol.Create({ col: 38, text: 'KGS', width: 60, dataIndex: 'kgs', type: XCol.XCellType.Double, align: XCol.XAlignType.Right, formatString: '#,##0.00', noNullOrEmptySearch: true }),
        XCol.Create({ col: 39, text: 'CBM', width: 60, dataIndex: 'cbm', type: XCol.XCellType.Double, align: XCol.XAlignType.Right, formatString: '#,##0.000', noNullOrEmptySearch: true }),
        XCol.Create({ col: 40, text: 'Loading Port', width: 120, dataIndex: 'lPort' }),
        XCol.Create({ col: 41, text: 'Final Dest', width: 120, dataIndex: 'fDest' }),
        XCol.Create({ col: 42, text: 'Commodity', width: 120, dataIndex: 'commodity' }),
        XCol.Create({ col: 43, text: 'Prep.', width: 80, dataIndex: 'operator' }),
        XCol.Create({ col: 44, text: 'CSR', width: 80, dataIndex: 'csr' }),
        XCol.Create({ col: 45, text: 'Customer Ref.', width: 100, dataIndex: 'custRefNo' }),
        XCol.Create({ col: 46, text: 'ETA', width: 75, dataIndex: 'eta', type: XCol.XCellType.Date, align: XCol.XAlignType.Center }),
        XCol.Create({ col: 47, text: 'F.ETA', width: 75, dataIndex: 'fEta', type: XCol.XCellType.Date, align: XCol.XAlignType.Center }),
        XCol.Create({ col: 48, text: 'L.F.D', width: 75, dataIndex: 'lastFreeDay', type: XCol.XCellType.Date, align: XCol.XAlignType.Center, visible: false }),
        XCol.Create({ col: 49, text: 'D.ETA', width: 75, dataIndex: 'doorDlvETA', type: XCol.XCellType.Date, align: XCol.XAlignType.Center, visible: false }),
        XCol.Create({ col: 50, text: 'Container', width: 90, dataIndex: 'cntrNo' }),
        XCol.Create({ col: 51, text: 'C. Type', width: 60, dataIndex: 'cntrType' }),
        XCol.Create({ col: 52, text: 'Sales', width: 80, dataIndex: 'sManID' }),
        XCol.Create({ col: 53, text: 'Agent', width: 120, dataIndex: 'aName' }),
        XCol.Create({ col: 54, text: 'Shipper', width: 120, dataIndex: 'sName', hasCustomTooltip: true }),
        XCol.Create({ col: 55, text: 'Consignee', width: 120, dataIndex: 'cName', hasCustomTooltip: true }),
        XCol.Create({ col: 56, text: 'Notify', width: 120, dataIndex: 'nName', hasCustomTooltip: true }),
        XCol.Create({ col: 57, text: 'Broker', width: 120, dataIndex: 'bName', hasCustomTooltip: true, visible: false }),
        XCol.Create({ col: 58, text: 'Sub MBL', width: 120, dataIndex: 'subMBl', visible: false }),
        XCol.Create({ col: 59, text: 'Sub HBL', width: 120, dataIndex: 'subBl', visible: false }),
        XCol.Create({ col: 60, text: 'Freight Location', width: 120, dataIndex: 'fWhse' }),
        XCol.Create({ col: 61, text: 'Dvn. EDI', width: 75, dataIndex: 'dvnEdi', type: XCol.XCellType.Date, align: XCol.XAlignType.Center, visible: false }),
        XCol.Create({ col: 62, text: 'Door Delivery', width: 120, dataIndex: 'doorDlvLoc' }),
        XCol.Create({ col: 63, text: 'Vessel', width: 120, dataIndex: 'vessel' }),
        XCol.Create({ col: 64, text: 'Voyage', width: 60, dataIndex: 'voyage' }),
        XCol.Create({ col: 65, text: 'Discharge Port', width: 80, dataIndex: 'dPort' }),
        

        
        // XCol.Create({ col: 6, text: 'Biz', width: 57, dataIndex: 'bizMode', tooltip: 'Biz Mode'}),
        
        // start - For Hbl Information 
        XCol.Create({ col: 66, text: 'Tracker', width: 75, dataIndex: 'trackerDate', type: XCol.XCellType.Date, align: XCol.XAlignType.Center }),
        XCol.Create({ col: 67, text: 'Last Tracked', width: 75, dataIndex: 'lastTrackedDate', type: XCol.XCellType.Date, align: XCol.XAlignType.Center }),
        XCol.Create({ col: 68, text: 'Send A/N', width: 75, dataIndex: 'anPrintedDate', type: XCol.XCellType.Date, align: XCol.XAlignType.Center }),
        XCol.Create({ col: 69, text: 'Rcv C. Doc', width: 75, dataIndex: 'cDocRcvdDate', type: XCol.XCellType.Date, align: XCol.XAlignType.Center }),
        XCol.Create({ col: 70, text: 'Send E. Doc', width: 75, dataIndex: 'eDocSentDate', type: XCol.XCellType.Date, align: XCol.XAlignType.Center }),
        XCol.Create({ col: 71, text: 'Rcv 7501', width: 75, dataIndex: 'f7501RcvdDate', type: XCol.XCellType.Date, align: XCol.XAlignType.Center }),
        XCol.Create({ col: 72, text: 'Rcv 3461', width: 75, dataIndex: 'f3461RcvdDate', type: XCol.XCellType.Date, align: XCol.XAlignType.Center }),
        XCol.Create({ col: 73, text: 'Customs Rls', width: 75, dataIndex: 'clearDate', type: XCol.XCellType.Date, align: XCol.XAlignType.Center }),
        XCol.Create({ col: 74, text: 'Customs Hold', width: 75, dataIndex: 'cHoldDate', type: XCol.XCellType.Date, align: XCol.XAlignType.Center }),
        XCol.Create({ col: 75, text: 'Exam On', width: 75, dataIndex: 'examOnDate', type: XCol.XCellType.Date, align: XCol.XAlignType.Center }),
        XCol.Create({ col: 76, text: 'Exam Off', width: 75, dataIndex: 'examOffDate', type: XCol.XCellType.Date, align: XCol.XAlignType.Center }),
        XCol.Create({ col: 77, text: 'PGA Hold', width: 75, dataIndex: 'fdaHoldDate', type: XCol.XCellType.Date, align: XCol.XAlignType.Center }),
        XCol.Create({ col: 78, text: 'PGA Rls', width: 75, dataIndex: 'fdaRlsDate', type: XCol.XCellType.Date, align: XCol.XAlignType.Center }),
        XCol.Create({ col: 79, text: 'Send IT', width: 75, dataIndex: 'inlandNoticeSentDate', type: XCol.XCellType.Date, align: XCol.XAlignType.Center }),
        XCol.Create({ col: 80, text: 'Send P/U Info', width: 75, dataIndex: 'puInfoSentDate', type: XCol.XCellType.Date, align: XCol.XAlignType.Center }),
        XCol.Create({ col: 81, text: 'Cfm DO', width: 75, dataIndex: 'doReceiptCfrmdDate', type: XCol.XCellType.Date, align: XCol.XAlignType.Center }),
        XCol.Create({ col: 82, text: 'Cfm D/A', width: 75, dataIndex: 'dlvAddrCfrmdDate', type: XCol.XCellType.Date, align: XCol.XAlignType.Center }),
        XCol.Create({ col: 83, text: 'Send DO', width: 75, dataIndex: 'doSentDate', type: XCol.XCellType.Date, align: XCol.XAlignType.Center }),
        XCol.Create({ col: 84, text: 'ETD', width: 75, dataIndex: 'dlvSchdDate', type: XCol.XCellType.Date, align: XCol.XAlignType.Center }),
        XCol.Create({ col: 85, text: 'ATD', width: 75, dataIndex: 'actDlvDate', type: XCol.XCellType.Date, align: XCol.XAlignType.Center }),
        XCol.Create({ col: 86, text: 'Rtn E. CNTR', width: 75, dataIndex: 'emptyRtnDate', type: XCol.XCellType.Date, align: XCol.XAlignType.Center }),
        XCol.Create({ col: 87, text: 'Rcv POD', width: 75, dataIndex: 'podRcvdDate', type: XCol.XCellType.Date, align: XCol.XAlignType.Center }),
        XCol.Create({ col: 88, text: 'Bill Complete', width: 75, dataIndex: 'billingCpldDate', type: XCol.XCellType.Date, align: XCol.XAlignType.Center }),
        XCol.Create({ col: 89, text: 'DDP', width: 75, dataIndex: 'ddpDate', type: XCol.XCellType.Date, align: XCol.XAlignType.Center }),
        XCol.Create({ col: 90, text: 'Remark', width: 150, dataIndex: 'remark'}),
        //end - Hbl Information
        
        XCol.Create({ col: 91, text: 'Pickup Date', width: 75, dataIndex: 'outDate', type: XCol.XCellType.Date, align: XCol.XAlignType.Center }),
        XCol.Create({ col: 92, text: 'Return Date', width: 75, dataIndex: 'emptyReturn', type: XCol.XCellType.Date, align: XCol.XAlignType.Center }),

        XCol.Create({ col: 93, text: 'Create Date', width: 100, dataIndex: 'createdAt', type: XCol.XCellType.DateTime, align: XCol.XAlignType.Center, visible: false }),
        XCol.Create({ col: 94, text: 'Create by', width: 80, dataIndex: 'u1ID', visible: false }),
        XCol.Create({ col: 95, text: 'Update Date', width: 100, dataIndex: 'u2Date', type: XCol.XCellType.DateTime, align: XCol.XAlignType.Center, visible: false }),
        XCol.Create({ col: 95, text: 'Update by', width: 80, dataIndex: 'u2ID', visible: false }),
    ];

    public static getExportCollection(ltype: OihListType, useBranch: boolean, isCanada: boolean = false): XCol.XExportColumn[] {
        let expCollection = _.cloneDeep(this.ExportCollection);

        let showInfo = false;
        switch (ltype) {
            case OihListType.Normal:
            case OihListType.UseLot:
                showInfo = false;
                break;
            case OihListType.HblInfo:
                showInfo = true;
                break;
            default:
                return [];
        }

        const infoCols = [
            'trackerDate',
            'lastTrackedDate',
            'anPrintedDate',
            'cDocRcvdDate',
            'eDocSentDate',
            'f7501RcvdDate',
            'f3461RcvdDate',
            'clearDate',
            'cHoldDate',
            'examOnDate',
            'examOffDate',
            'fdaHoldDate',
            'fdaRlsDate',
            'inlandNoticeSentDate',
            'puInfoSentDate',
            'doReceiptCfrmdDate',
            'doSentDate',
            'dlvAddrCfrmdDate',
            'dlvSchdDate',
            'actDlvDate',
            'emptyRtnDate',
            'podRcvdDate',
            'billingCpldDate',
            'ddpDate',
            //'anLastLogDate', //A/N 컬럼은 항상 표시되도록 변경
        ];

        if (!showInfo) expCollection = expCollection.filter(x => !infoCols.includes(x.dataIndex));
        if (!useBranch) expCollection = expCollection.filter(x => x.dataIndex !== 'branch');
        if (isCanada) expCollection = expCollection.filter(x => !['useAmsBlNo', 'amsBlNo', 'chbRspCode', 'itNo'].includes(x.dataIndex));
        else expCollection = expCollection.filter(x => !['emptyReturn', 'outDate'].includes(x.dataIndex));

        return expCollection;
    };
	
    public static OrderBy = { orderBy: OiHblListItem.prototype.createdAt , orderByAscending: false };

    public static formatData(data: OiHblListItem[]) {
        return data.map((d: OiHblListItem) => ({
          ...d,
        }));
    }

    public static MapSearchFields: {[key: string]: {[key: string]: string}} = {
        oblDate: { from: 'fromOblDate', to: 'toOblDate'},
        rlsDate: { from: 'fromRlsDate', to: 'toRlsDate'},
        payDate: { from: 'fromPayDate', to: 'toPayDate'},
        lastFreeDay: { from: 'fromLastFreeDay', to: 'toLastFreeDay'},
        eta: { from: 'fromEta', to: 'toEta'},
        fEta: { from: 'fromFEta', to: 'toFEta'},
        doorDlvETA: { from: 'fromDoorDlvETA', to: 'toDoorDlvETA'},
        u2Date: { from: 'fromU2Date', to: 'toU2Date'},
        cDocRcvdDate: { from: 'fromCDocRcvdDate', to: 'toCDocRcvdDate'},
        eDocSentDate: { from: 'fromEDocSentDate', to: 'toEDocSentDate'},
        f7501RcvdDate: { from: 'fromF7501RcvdDate', to: 'toF7501RcvdDate'},
        f3461RcvdDate: { from: 'fromF3461RcvdDate', to: 'toF3461RcvdDate'},
        inlandNoticeSentDate: { from: 'fromInlandNoticeSentDate', to: 'toInlandNoticeSentDate'},
        puInfoSentDate: { from: 'fromPuInfoSentDate', to: 'toPuInfoSentDate'},
        doReceiptCfrmdDate: { from: 'fromDoReceiptCfrmdDate', to: 'toDoReceiptCfrmdDate'},
        dlvAddrCfrmdDate: { from: 'fromDlvAddrCfrmdDate', to: 'toDlvAddrCfrmdDate'},
        doSentDate: { from: 'fromDoSentDate', to: 'toDoSentDate'},
        dlvSchdDate: { from: 'fromDlvSchdDate', to: 'toDlvSchdDate'},
        actDlvDate: { from: 'fromActDlvDate', to: 'toActDlvDate'},
        emptyRtnDate: { from: 'fromEmptyRtnDate', to: 'toEmptyRtnDate'},
        podRcvdDate: { from: 'fromPodRcvdDate', to: 'toPodRcvdDate'},
        billingCpldDate: { from: 'fromBillingCpldDate', to: 'toBillingCpldDate'},
        anPrint: { from: 'fromAnPrint', to: 'toAnPrint'},
        anPrintedDate: { from: 'fromANPrintedDate', to: 'toANPrintedDate'},
        anFax: { from: 'fromAnFax', to: 'toAnFax'},
        anEmail: { from: 'fromAnEmail', to: 'toAnEmail'},
        createdAt: { from: 'fromCreatedAt', to: 'toCreatedAt'},
        pkgs: { from: 'fromPkgs', to: 'toPkgs'},
        trackerDate: { from: 'fromTrackerDate', to: 'toTrackerDate'},
        lastTrackedDate: { from: 'fromLastTrackedDate', to: 'toLastTrackedDate'},
        fdaHoldDate: { from: 'fromFdaHoldDate', to: 'toFdaHoldDate'},
        fdaRlsDate: { from: 'fromFdaRlsDate', to: 'toFdaRlsDate'},
        clearDate: { from: 'fromClearDate', to: 'toClearDate'},
        cHoldDate: { from: 'fromCHoldDate', to: 'toCHoldDate'},
        examOnDate: { from: 'fromExamOnDate', to: 'toExamOnDate'},
        examOffDate: { from: 'fromExamOffDate', to: 'toExamOffDate'},
        ddpDate: { from: 'fromDdpDate', to: 'toDdpDate'},
        lbs: { from: 'fromLbs', to: 'toLbs'},
        kgs: { from: 'fromKgs', to: 'toKgs'},
        cbm: { from: 'fromCbm', to: 'toCbm'},
        trDate: {from: 'fromTrDate', to: 'toTrDate' },
        dvnEdi: {from: 'fromDvnEdi', to: 'toDvnEdi' },
        confirmDate: {from: 'fromConfirmDate', to: 'toConfirmDate'},
        anLastLogDate: { from: 'fromAnLastLogDate', to: 'toAnLastLogDate'},
        emptyReturn: { from: 'fromEmptyReturn', to: 'toEmptyReturn'},
        outDate: { from: 'fromOutDate', to: 'toOutDate'},
    }
}
